import { AnyObject } from '@feedyou/utils'

export function setMissingOriginalPropsWithUndefinedValue<T extends AnyObject>(params: {
  newObject: T
  originalObject: T
  readonlyKeys?: string[]
}): T {
  const newKeys = Object.keys(params.newObject)
  const originalKeys = Object.keys(params.originalObject)

  const isOriginalPropMissing = (key: string) =>
    !params.readonlyKeys?.includes(key) && !newKeys.includes(key)

  const missingOriginalProps = originalKeys
    .filter(isOriginalPropMissing)
    .reduce((output, missingKey) => ({ ...output, [missingKey]: undefined }), {})

  return { ...params.newObject, ...missingOriginalProps }
}
